import { useSelector } from 'react-redux';
import { RootState } from '../app/stores/store';

export { useApiResult };

function useApiResult<T = any>(id: string) {
    const apiCalls = useSelector((state: RootState) => state.apiCalls);
    return apiCalls.calls.find((x: any) => x.id === id)?.result as T;
}
